import "./Confirm.css"

import type { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"

interface ConfirmProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  type: "delete" | "discardChanges" | "logout"
  message?: string
  title?: string
  confirmFunc: () => void
  loading?: boolean
}

export default function Confirm({
  isOpen,
  setIsOpen,
  type,
  message,
  title,
  confirmFunc,
  loading,
}: ConfirmProps) {
  const { t } = useTranslation()

  const content = {
    delete: {
      primary: t("confirm.delete.primary"),
      secondary: t("confirm.delete.secondary"),
      message: t("confirm.delete.message"),
      title: t("confirm.delete.title"),
    },
    discardChanges: {
      primary: t("confirm.discardChanges.primary"),
      secondary: t("confirm.discardChanges.secondary"),
      message: t("confirm.discardChanges.message"),
      title: t("confirm.discardChanges.title"),
    },
    logout: {
      primary: t("confirm.logout.primary"),
      secondary: t("confirm.logout.secondary"),
      title: t("confirm.logout.title"),
      message: "",
    },
  }

  return (
    <MyModal
      modalName={MODALS.confirm.index}
      size="sm"
      title={title || content[type]?.title}
      titleClassname="fs-5"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <p className="confirm__message fs-5">
        {message || content[type]?.message}
      </p>
      <div className="d-flex gap-3 justify-content-end">
        <Button
          variant="secondary_border"
          fixedWidth
          onClick={() => setIsOpen(false)}
        >
          {content[type]?.secondary}
        </Button>
        <Button
          variant="red"
          fixedWidth
          onClick={confirmFunc}
          isLoading={loading}
        >
          {content[type]?.primary}
        </Button>
      </div>
    </MyModal>
  )
}
